import React, { useEffect, useState } from "react";
import
{
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormFeedback,
  Alert,
  Spinner,
} from "reactstrap";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";

//redux
import { useSelector, useDispatch } from "react-redux";

import { withRouter, Link, useHistory } from "react-router-dom";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withTranslation } from "react-i18next";

// actions
import
{
  loginUser,
  socialLogin,
  resetLoginFlag,
  loginSuccess,
  apiError,
} from "../../store/actions";

import logoLight from "../../assets/images/logo-light.png";
import axios from "axios";
import axiosInstance from "../../axiosConfig";

const Login = ( props ) =>
{
  document.title = props.t( "Connexion | Takci - Admin" );
  const history = useHistory();

  const [ errorMsg, setErrorMsg ] = useState( null );
  const [ loading, setloading ] = useState( false );
  const [ passwordShow, setPasswordShow ] = useState( false );
  // const [ userLogin, setUserLogin ] = useState( [] );

  const validation = useFormik( {
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object( {
      email: Yup.string().required( "Please Enter Your Email" ),
      password: Yup.string().required( "Please Enter Your Password" ),
    } ),
    onSubmit: ( values ) =>
    {
      setErrorMsg( null );
      setloading( true );

      // console.log( "onsubmit values : ", values );
      axios
        .post( `${process.env.REACT_APP_API_URL}/adminlogin/`, values )
        .then( ( res ) =>
        {
          // console.log("res: ", res);

          setTimeout( () =>
          {
            setloading( false );
            sessionStorage.setItem( "authUser", JSON.stringify( res ) );
            localStorage.setItem( "authUser", JSON.stringify( res ) );
            history.push( "/profile" );
            // Utilisez un timeout pour assurer que l'historique est mis à jour avant le rechargement
            //   setTimeout(() => {
            //     window.location.reload();
            //   }, 0);
          }, 500 );
        } )
        .catch( ( error ) =>
        {
          console.error( error );
          setErrorMsg( "Email ou mot de passe incorrect !" );
          setloading( false );
        } );
    },
  } );

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">
          <Container>
            <Row>
              <Col lg={ 12 }>
                <div className="text-center mt-sm-5 text-white-50">
                  <div>
                    <Link to="/" className="d-inline-block auth-logo">
                      <img src={ logoLight } alt="" height="50" />
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col md={ 8 } lg={ 6 } xl={ 5 }>
                <Card className="mt-4">
                  <CardBody className="p-4">
                    <div className="text-center mt-2">
                      <h5 className="text-primary">{ props.t( "Welcome" ) } !</h5>
                      <p className="text-muted">
                        Connectez-vous pour continuer avec Takci.
                      </p>
                    </div>
                    { errorMsg ? (
                      <Alert color="danger"> { errorMsg } </Alert>
                    ) : null }
                    <div className="p-2 mt-4">
                      <Form
                        onSubmit={ ( e ) =>
                        {
                          e.preventDefault();
                          validation.handleSubmit();
                        } }
                      >
                        <div className="mb-3">
                          <Label htmlFor="email" className="form-label">
                            Email
                          </Label>
                          <Input
                            name="email"
                            className="form-control"
                            placeholder={ props.t( "Enter You Email" ) }
                            type="email"
                            onChange={ validation.handleChange }
                            onBlur={ validation.handleBlur }
                            value={ validation.values.email || "" }
                          />
                          { validation.touched.email &&
                            validation.errors.email ? (
                            <FormFeedback type="invalid">
                              { validation.errors.email }
                            </FormFeedback>
                          ) : null }
                        </div>

                        <div className="mb-3">
                          <div className="float-end">
                            <Link to="/forgot-password" className="text-muted">
                              Mot de passe oublié?
                            </Link>
                          </div>
                          <Label
                            className="form-label"
                            htmlFor="password-input"
                          >
                            Mot de passe
                          </Label>
                          <div className="position-relative auth-pass-inputgroup mb-3">
                            <Input
                              name="password"
                              type={ passwordShow ? "text" : "password" }
                              className="form-control pe-5"
                              placeholder={ props.t( "Enter Your Password" ) }
                              value={ validation.values.password || "" }
                              onChange={ validation.handleChange }
                              onBlur={ validation.handleBlur }
                              invalid={
                                validation.touched.password &&
                                  validation.errors.password
                                  ? true
                                  : false
                              }
                            />
                            { validation.touched.password &&
                              validation.errors.password ? (
                              <FormFeedback type="invalid">
                                { validation.errors.password }
                              </FormFeedback>
                            ) : null }
                            <button
                              onClick={ () => setPasswordShow( !passwordShow ) }
                              className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                              type="button"
                              id="password-addon"
                            >
                              { passwordShow ? (
                                <i className="ri-eye-off-fill align-middle"></i>
                              ) : (
                                <i className="ri-eye-fill align-middle"></i>
                              ) }
                            </button>
                          </div>
                        </div>

                        {/* <div className="form-check">
                                                    <Input className="form-check-input" type="checkbox" value="" id="auth-remember-check" />
                                                    <Label className="form-check-label" htmlFor="auth-remember-check">Se rappeler de moi</Label>
                                                </div> */}

                        <div className="mt-4">
                          <Button
                            disabled={ loading ? true : false }
                            style={ { backgroundColor: "#01064a" } }
                            className="btn w-100 text-white"
                            type="submit"
                          >
                            { loading ? (
                              <Spinner size="sm" className="me-2">
                                { " " }
                                { props.t( "loading" ) }...{ " " }
                              </Spinner>
                            ) : null }
                            { props.t( "Login" ) }
                          </Button>
                        </div>

                        {/* <div className="mt-4 text-center">
                                                    <div className="signin-other-title">
                                                        <h5 className="fs-13 mb-4 title">Sign In with</h5>
                                                    </div>
                                                    <div>
                                                        <FacebookLogin
                                                            appId={facebook.APP_ID}
                                                            autoLoad={false}
                                                            callback={facebookResponse}
                                                            render={renderProps => (
                                                                <Button color="primary"
                                                                    className="btn-icon me-1"
                                                                    onClick={renderProps.onClick}
                                                                >
                                                                    <i className="ri-facebook-fill fs-16" />
                                                                </Button>
                                                            )}
                                                        />
                                                        <GoogleLogin
                                                            clientId={
                                                                google.CLIENT_ID ? google.CLIENT_ID : ""
                                                            }
                                                            render={renderProps => (
                                                                <Button color="danger"
                                                                    to="#"
                                                                    className="btn-icon me-1"
                                                                    onClick={renderProps.onClick}
                                                                >
                                                                    <i className="ri-google-fill fs-16" />
                                                                </Button>
                                                            )}
                                                            onSuccess={googleResponse}
                                                            onFailure={() => {

                                                            }}
                                                        />
                                                        <Button color="dark" className="btn-icon"><i className="ri-github-fill fs-16"></i></Button>{" "}
                                                        <Button color="info" className="btn-icon"><i className="ri-twitter-fill fs-16"></i></Button>
                                                    </div>
                                                </div> */}
                      </Form>
                    </div>
                  </CardBody>
                </Card>

              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default withRouter( withTranslation()( Login ) );
